<template>
	<router-link @click.native.prevent="" custom class="router-link" :to="{ name: 'Features', params: { pID: project.id } }">
		<div class="project-details-card">
			<div class="display-flex flex-row flex-justify-space-between flex-align-center">
				<div class="display-flex flex-row flex-justify-space-between flex-align-center">
					<SpaceIconCard class="mr-2" v-if="!isVirtual">
						<SIcon width="10" :name="projectIconIndicatorName" />
					</SpaceIconCard>
					<div class="project-title">{{ projectTitle }}</div>
				</div>
				<ProjectMenuSettingsDropdown class="mt-n2" v-if="hasPermissionToSeeSettings" :project="project" />
			</div>
			<div class="content-container display-flex flex-column flex-justify-space-between mt-3">
				<div class="description">{{ project.description }}</div>
				<div class="display-flex flex-row flex-justify-space-between flex-align-center pr-2">
					<div class="details-text">{{ projectDetails }}</div>
					<ProjectAvatars :numToShow="5" v-if="!isVirtual" :key="project.id" :projectId="project.id" :fetchData="fetchData" />
				</div>
			</div>
		</div>
	</router-link>
</template>

<script>
import { mapGetters } from 'vuex';

import { ProjectPermissions } from '@ply-io/ply-front-shared-utilities';

import ProjectAvatars from '@/components/ProjectMenu/ProjectAvatars.vue';
import ProjectMenuSettingsDropdown from '@/components/ProjectMenu/ProjectMenuSettingsDropdown.vue';
import { projectHasPermission } from '@/store/modules/projects/getters';
import { pluralize } from '@/utils/language-service';
import ProjectService from '@/utils/projects-service';
import SpaceIconCard from '@/views/AppLayout/ManageAndCreate/SpaceIconCard.vue';
export default {
	name: 'ProjectDetailsCard',
	props: {
		project: { type: Object },
		isVirtual: { type: Boolean },
		fetchData: { type: Boolean, default: true },
	},
	components: { ProjectAvatars, ProjectMenuSettingsDropdown, SpaceIconCard },
	computed: {
		...mapGetters([projectHasPermission.fullPath]),
		showSetting() {
			return this.hasPermissionToSeeSettings;
		},
		hasPermissionToSeeSettings() {
			return this[projectHasPermission.fullPath](this.project.id, ProjectPermissions.ViewSettings);
		},
		projectTitle() {
			return this.project.title || '';
		},
		numOfFlows() {
			return this.project.workflowsCount || this.project.flows?.length || 0;
		},
		projectDetails() {
			return `${pluralize('feature', this.numOfFlows, true)}`;
		},
		projectIconIndicatorName() {
			return `${this.isPersonalProject ? 'personal' : 'collaborative'}-space`;
		},
		isPersonalProject() {
			return ProjectService.isPersonalProject(this.project);
		},
	},
};
</script>

<style scoped lang="scss">
.router-link {
	text-decoration: none !important;
}
.project-details-card {
	width: 450px;
	height: 170px;
	border-radius: 10px;
	background: var(--white);
	padding: 18px 8px 18px 22px;
	border: 1px solid #e5e5e5;

	&:hover {
		transition: 0.3s;
		box-shadow: 0px 3px 6px var(--shadow-color);
	}

	.project-title {
		font-size: 16px;
		font-weight: 500;
		color: var(--primary-font-color);
	}
	.description {
		overflow: hidden;
		white-space: pre-wrap;
		word-break: break-word;
		text-overflow: ellipsis;
	}
	.description,
	.details-text {
		font-size: 14px;
		color: #9e9e9e;
	}
}
.content-container {
	height: calc(100% - 36px);
}
</style>
